import { AddRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CreateLoanButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      startIcon={<AddRounded />}
      size="small"
      onClick={() => navigate("/loan/create")}
    >
      Create Loan
    </Button>
  );
};

export default CreateLoanButton;
